import { render, staticRenderFns } from "./veStuIdx.vue?vue&type=template&id=18c1aea5&scoped=true"
import script from "./veStuIdx.vue?vue&type=script&lang=js"
export * from "./veStuIdx.vue?vue&type=script&lang=js"
import style0 from "./veStuIdx.vue?vue&type=style&index=0&id=18c1aea5&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18c1aea5",
  null
  
)

export default component.exports